/**
 * MIT License
 * Copyright (c) 2023 Jamasp Team
 */
import { useEffect, useCallback } from 'react';
import ProlificRegistrationStepper from '../components/register/ProlificRegistrationStepper';
import { useAlert } from '../context/AlertContext';
import { useRegistration } from '../context/RegistrationContext';
import { checkProjectForRegistration } from '../services/RegistrationService';

export default function ProlificRegistration() {
  const {
    pid, setPid, projectId, activeStep, loading,
    storePid, participantId, initiateFitbitAuth,
    renewRegistration, handleError,
  } = useRegistration();

  const { addAlert } = useAlert();

  useEffect(() => {
    const checkProjectStatus = async () => {
      if (!projectId) return;
      try {
        const result = await checkProjectForRegistration(projectId);
        if (!result) console.error('Check project status failed', result);
      } catch (err) {
        handleError(err, 'Error checking project status. Please try again.');
      }
    };
    checkProjectStatus();
    // eslint-disable-next-line
  }, [projectId, addAlert]);

  const handlePidChange  = useCallback((v) => setPid(v), [setPid]);
  const handleStorePid   = useCallback(() => storePid(), [storePid]);
  const handleFitbitAuth = useCallback(() => initiateFitbitAuth(), [initiateFitbitAuth]);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#FBFCFE',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'DM Sans', sans-serif",
      padding: '24px 16px',
    }}>
      <div style={{
        background: '#fff',
        border: '1px solid #D6E2EB',
        borderRadius: 12,
        padding: '36px 40px',
        width: '100%',
        maxWidth: 480,
        boxShadow: '0 4px 24px rgba(9,89,170,0.07)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 18,
            fontWeight: 500,
            color: '#0A66C2',
            letterSpacing: '0.5px',
          }}>
            jamasp
          </span>
        </div>

        <ProlificRegistrationStepper
          pid={pid}
          activeStep={activeStep}
          participantId={participantId}
          loading={loading}
          onPidChange={handlePidChange}
          onStorePid={handleStorePid}
          onInitiateFitbitAuth={handleFitbitAuth}
          onRenewRegistration={renewRegistration}
        />
      </div>
    </div>
  );
}
